import { IConfig } from '@cian/config/shared';

const CONFIG_KEY = 'Newbuilding.PhoneCallbacks.Notifications.Enabled';

export const getSmsDisclaimerState = (config: IConfig) => {
  return !!config.get<boolean>(CONFIG_KEY);
};
